var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import styled from 'styled-components';
import useActiveThemeVariation from '../../../../themes/hooks/UseActiveThemeVariation';
import useTheme from '../../../../themes/hooks/UseTheme';
import StackLayout from '../../../layouts/stackLayout/StackLayoutComponent';
import useBottomSheetStore from '../dataLayer/hooks/UseBottomSheetStore';
var StyledBottomSheet = styled(BottomSheet)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  [data-rsbs-header=\"true\"]{\n    background: ", ";\n  }\n\n  [data-rsbs-header=\"true\"]::before{\n    background: ", ";\n  }\n"], ["\n  [data-rsbs-header=\"true\"]{\n    background: ", ";\n  }\n\n  [data-rsbs-header=\"true\"]::before{\n    background: ", ";\n  }\n"])), function (props) { return props.backgroundColor; }, function (props) { return props.iconColor; });
var BottomSheetImplementation = function (props) {
    var bottomSheetStore = useBottomSheetStore();
    var bottomSheetKey = props.bottomSheetKey, children = props.children;
    var theme = useTheme();
    var activeThemeVariation = useActiveThemeVariation(props, function (x) { return x.advancedControlsThemes.bottomSheet; });
    var handleDismiss = useCallback(function () {
        bottomSheetStore.closeBottomSheet();
    }, []);
    return (React.createElement(StyledBottomSheet, { open: bottomSheetStore.isOpen(bottomSheetKey), onDismiss: handleDismiss, backgroundColor: theme.resolveColor(activeThemeVariation.backgroundColor), iconColor: theme.resolveColor(activeThemeVariation.iconColor) },
        React.createElement(StackLayout, __assign({}, activeThemeVariation, { backgroundColor: { custom: 'green' } }), children)));
};
export default BottomSheetImplementation;
var templateObject_1;
//# sourceMappingURL=BottomSheetImplementation.js.map